export class DataUnit {
  id!: number;
  name!: string;
}
